// Santa's mailbox (footer newsletter signup).
// When the shopper submits their email, the letter drops into the slot, the box gives a happy wobble and the flag
// pops, and then the form is sent. After a successful signup the page reloads with a sparkle burst around the slot.
// With reduced motion the form is sent straight away and nothing animates.
const SEND_MS = 900;

class SMailbox extends HTMLElement {
  connectedCallback() {
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.addEventListener('submit', this.onSubmit);
    if (new URLSearchParams(window.location.search).get('customer_posted') === 'true' && !this.reduceMotion) {
      requestAnimationFrame(() => this.celebrate());
    }
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.onSubmit);
  }

  onSubmit = (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || this.reduceMotion || form.dataset.mailSent) return;
    event.preventDefault();
    form.dataset.mailSent = 'true';
    form.querySelector('button[type="submit"]')?.setAttribute('aria-busy', 'true');
    this.playDrop();
    window.setTimeout(() => form.submit(), SEND_MS);
  };

  playDrop() {
    const letter = this.querySelector('[data-mail-letter]');
    const box = this.querySelector('[data-mail-box]');
    const flag = this.querySelector('[data-mail-flag]');
    const slot = this.querySelector('[data-mail-slot]');
    if (letter) letter.style.animation = `mail-send ${SEND_MS}ms cubic-bezier(.5,0,.75,0) forwards`;
    if (box) box.style.animation = `mailbox-wobble 600ms ease-in-out ${SEND_MS - 250}ms`;
    if (flag) flag.style.animation = `mailbox-flag-pop 700ms ease-out ${SEND_MS - 300}ms`;
    if (slot) slot.style.animation = `mail-slot-glow 700ms ease-out ${SEND_MS - 300}ms`;
  }

  celebrate() {
    const slot = this.querySelector('[data-mail-slot]');
    if (!slot) return;
    this.playDrop();
    const symbols = ['✨', '❄', '⭐', '✨', '❤', '❄', '✨', '⭐', '✨', '❄'];
    symbols.forEach((symbol, index) => {
      const spark = document.createElement('span');
      const angle = (index / symbols.length) * Math.PI * 2;
      const distance = 70 + (index % 3) * 22;
      spark.textContent = symbol;
      spark.setAttribute('aria-hidden', 'true');
      spark.style.cssText = 'position:absolute;inset-inline-start:50%;top:50%;z-index:20;pointer-events:none;font-size:1.25rem;line-height:1;color:var(--color-candy-gold);';
      spark.style.setProperty('--spark-x', `${Math.cos(angle) * distance}px`);
      spark.style.setProperty('--spark-y', `${Math.sin(angle) * distance * 0.7 - 20}px`);
      spark.style.animation = `mail-spark 1100ms ease-out ${SEND_MS - 200 + index * 30}ms both`;
      slot.appendChild(spark);
      window.setTimeout(() => spark.remove(), SEND_MS + 1600);
    });
  }
}

if (!customElements.get('s-mailbox')) customElements.define('s-mailbox', SMailbox);
